export class ConfiguracioncreditoModel {
    constructor(
        public maximo_credito_general: any,
        public maximo_credito_cliente: any,
        public tasa_mora: any,
        public dias_expiracion: number,
        public valor_minimo_credito: any
    ) { }
}